// Material UI
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTextField-root': {
        width: '40px'
      },
      '& .MuiTableCell-head': {
        fontWeight: 'bold'
      },
      '& .MuiTableCell-root': {
        [theme.breakpoints.down('xs')]: {
          padding: '6px 0px 6px 12px'
        },
      },
      '& a': {
        color: theme.palette.primary.main
      }
    },
    tableWrapper: {
      borderCollapse: 'separate',
      '& .MuiTableHead-root .MuiTableCell-root': {
        backgroundColor: theme.palette.grey[600],
        color: 'white',
        lineHeight: '1rem'
      },
      '& .MuiTableHead-root .MuiTableCell-root:first-child': {
        borderTopLeftRadius: '6px',
        borderBottomLeftRadius: '6px'
      },
      '& .MuiTableHead-root .MuiTableCell-root:last-child': {
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px'
      },
      '& .MuiTableCell-root': {
        textAlign: 'center'
      },
    },
    cardTop: {
      minHeight: '200px',
      display: 'flex',
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        minHeight: '140px',
      },
    },
    priceCol: {
      minWidth: '105px',
      '& .MuiTypography-root': {
        display: 'inline-block',
        marginRight: theme.spacing(1)
      }
    },
    cardMedia: {
      width: '30%',
      display: 'flex',
      alignItems: 'center',
      '& img': {
        width: '100%',
        height: 'auto',
        maxHeight: '200px',
        objectFit: 'contain',
        borderRadius: '4px',
        [theme.breakpoints.down('xs')]: {
          maxHeight: '140px',
        },
      }
    },
    cardDescription: {
      width: '70%',
      padding: theme.spacing(2)
    },
    lineThrough: {
      textDecoration: 'line-through'
    },
    noStockMsg: {
      margin: theme.spacing(2, 0) 
    },
    itemsTable: {
      '& .MuiTableRow-root': {
        borderLeft: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)'
      },
      '& .MuiTableCell-root': {
        borderTop: '1px solid rgba(224, 224, 224, 1)',
      },
      '& .MuiTableCell-root p': {
        margin: 0,
      }
    },
    type: {
      padding: '2px 5px 4px',
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '4px',
      marginLeft: '10px',
      verticalAlign: 'text-bottom',
      display: 'inline-block',
      fontSize: '14px'
    },
    inputQty: {
      border: `1px solid ${theme.palette.grey[300]}`,
      padding: '0 3px',
      width: '58px',
      margin: '0 auto',
      [theme.breakpoints.down('xs')]: {
        width: '45px',
      },
      '& .MuiSelect-icon': {
        right: '-3px'
      },
      '& .MuiSelect-select': {
        paddingRight: '8px'
      },
      '&.MuiInput-underline:before': {
        display: 'none'
      }
    }
  }),
);

export default useStyles;
